<template>
  <!-- <transition name="fade" mode="out-in"> -->
  <div class="screen-wrap">
    <v-app class="hmc-app">
      <v-main class="main-body" :style="intraction">
        <transition name="fade">
          <v-dialog
            v-model="portalClosedDialog"
            max-width="300"
            class="rounded-xl"
          >
            <v-card class="pb-5" rounded="xl">
              <v-card-title
                class="
                  text-h5
                  teal--text
                  text--darken-3
                  d-flex
                  justify-space-between
                  pt-0
                  pe-0
                "
              >
                <v-spacer></v-spacer>
                <CloseBtn
                  size="30"
                  :callback="
                    () => {
                      portalClosedDialog = false;
                    }
                  "
                />
              </v-card-title>
              <v-card-text class="text-center">
                <v-img
                  :src="require('@/assets/world/hamochi.png')"
                  width="140"
                  contain
                  class="mx-auto"
                ></v-img>
                <div class="text-h6 font-weight-bold mt-3">
                  {{ $t("view.PageWorldFun.portalClosedTitle") }}
                </div>
                <p class="text-body-2 mt-2">
                  {{
                    $t("view.PageWorldFun.portalClosedDescription", {
                      start: formatHour(portalStartHour),
                      end: formatHour(portalEndHour),
                    })
                  }}
                </p>
              </v-card-text>
            </v-card>
          </v-dialog>
        </transition>
        <MovedDialog
          v-if="movedDialog"
          :callbackClose="() => (movedDialog = false)"
          :showDialog="true"
          :message="movedMsg"
          :image="movedRefImg"
        />
        <v-container class="app-body">
          <div class="pe-2 ps-3 app-title text-h5">
            {{ $t("title.town") }}
            <v-spacer></v-spacer>
            <CloseBtn size="40" :callback="exit" id="goBackBtn" />
          </div>
          <div class="pa-5">
            <v-row>
              <v-col
                cols="4"
                v-for="(item, i) in items"
                :key="i"
                style="position: relative"
              >
                <v-img
                  v-if="!item.isLock || (item.isLock && settings.debug)"
                  :id="item.tutId"
                  :src="item.icon"
                  width="150"
                  :class="[
                    'd-flex',
                    'justify-center',
                    'align-end',
                    'text-center',
                    'text-stroke-sm',
                    'text-h6',
                    'menu-item',
                    { 'menu-item-closed': isItemClosed(item) },
                  ]"
                  @click="() => handleMenuClick(item)"
                >
                  {{ item.name }}
                </v-img>
                <div
                  v-else
                  style="aspect-ratio: 1"
                  class="d-flex align-center justify-center"
                >
                  <v-icon color="cyan lighten-2">mdi-circle</v-icon>
                </div>
                <v-img
                  v-if="item.isMoved"
                  style="position: absolute; top: 0; left: 0"
                  :src="
                    require(`@/assets/explore/menu/moved_${$_getLocale()}.png`)
                  "
                  @click="
                    movedDialog = true;
                    movedRefImg = item.movedRefImg;
                    movedMsg = item.movedMsg;
                  "
                ></v-img>
              </v-col>
              <v-col
                cols="4"
                v-for="i in 15 - items.length"
                :key="i + items.length"
              >
                <div
                  style="aspect-ratio: 1"
                  class="d-flex align-center justify-center"
                >
                  <v-icon color="cyan lighten-2">mdi-circle</v-icon>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-main>
      <SkipTut />
    </v-app>
  </div>
  <!-- </transition> -->
</template>
      
  <script>
import { mapState } from "vuex";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    SkipTut: () =>
      import(
        /* webpackChunkName: "component-skip-tut" */ "@/components/tutorial/SkipTut"
      ),
    MovedDialog: () =>
      import(
        /* webpackChunkName: "component-moved-dialo" */ "@/components/MovedDialog"
      ),
  },
  computed: mapState({
    settings: (state) => state.settings.data,
    auth: (state) => state.auth.data,
    tutorial: (state) => state.tutorial.data,
  }),
  props: [
    //
  ],
  data: () => ({
    intraction: null,
    items: [],
    movedDialog: false,
    movedRefImg: "",
    movedMsg: "",
    portalClosedDialog: false,
    portalEnabled: false,
    portalStartHour: 18,
    portalEndHour: 22,
  }),
  created() {
    this.updatePortalState();
  },
  mounted() {
    this.updatePortalState();
    this.items = [
      {
        name: "ABC",
        page: "PageABCBooks",
        icon: require("@/assets/explore/menu/abc.png"),
        isLock: false,
      },
      {
        name: this.$t("string.maths"),
        page: "PageMath",
        icon: require("@/assets/explore/menu/maths.png"),
        isLock: false,
      },
      {
        name: this.$t("title.hamochi_cup"),
        page: "PageExploreSeries",
        icon: require("@/assets/explore/menu/prize.png"),
        isLock: false,
      },
      {
        name: this.$t("string.news"),
        page: "PageWorldNews",
        icon: require("@/assets/explore/menu/news.png"),
        isLock: false,
      },
      {
        name: this.$t("string.mail"),
        page: "PageExploreMail",
        icon: require("@/assets/explore/menu/mailbox.png"),
        isLock: false,
      },
      {
        name: this.$t("view.PageFunArenaLanding.title"),
        page: "PageFunArenaLanding",
        icon: require("@/assets/explore/menu/funArena.png"),
        tutId: "tutFunArena",
        isLock: false,
        isOpen: this.portalEnabled,
      },
      {
        name: this.$t("string.collection"),
        page: "PageExploreCollections",
        icon: require("@/assets/explore/menu/collection.png"),
        tutId: "tutColl",
        isLock: false,
      },
      {
        name: this.$t("string.family"),
        page: "PageExploreFamily",
        icon: require("@/assets/explore/menu/family.png"),
        isLock: false,
      },
      {
        name: this.$t("string.classmates"),
        page: "PageExploreClassmates",
        icon: require("@/assets/explore/menu/school.png"),
        isLock: false,
      },
      {
        name: this.$t("title.shop"),
        page: "PageHomeShop",
        icon: require("@/assets/explore/menu/shop.png"),
        tutId: "ShopNow",
        isLock: false,
      },
      {
        name: this.$t("title.wardrobe"),
        page: "PageHomeWardrobe",
        icon: require("@/assets/explore/menu/wardrobe.png"),
        tutId: "tutWar",
        isLock: false,
      },
      {
        name: this.$t("title.gallery"),
        page: "PageHomeGallery",
        icon: require("@/assets/explore/menu/gallery.png"),
        tutId: "tutGall",
        isLock: false,
      },
      {
        name: this.$t("title.studio"),
        page: "PageHomeStudio",
        icon: require("@/assets/explore/menu/studio.png"),
        tutId: "tutStd",
        isLock: false,
      },
      {
        name: this.$t("title.locksmith"),
        page: "PageHomeLocksmith",
        icon: require("@/assets/explore/menu/locksmith.png"),
        tutId: "tutLock",
        isLock: false,
      },
      {
        name: this.$t("title.certificates"),
        page: "PageExploreCertificates",
        icon: require("@/assets/explore/menu/cert.png"),
        tutId: "tutLock",
        isLock: false,
      },
      // {
      //   name: this.$t("title.tower"),
      //   page: "PageExploreDailyGame",
      //   icon: require("@/assets/explore/menu/tower.png"),
      //   tutId: "tutTow",
      //   isLock: false,
      //   isMoved: true,
      //   movedRefImg: require("@/assets/explore/menu/towerMoved.png"),
      //   movedMsg: this.$t("string.movedMsg"),
      // },
    ];

    // #tutExploreShop - continue intro js ecplore Shop tutorial
    if (this.tutorial.Ongoing == "tutExploreShop") {
      let tempTut = this.$_.cloneDeep(this.tutorial);
      tempTut.Ongoing = "tutExploreShop";
      tempTut.Step = 3;
      this.$store.commit("updateTutorial", tempTut);
      this.startIntroJS("#ShopNow", this.$t("tutorial.exploreShop.dialog_3"));
    }

    if (this.tutorial.Ongoing == "tutWroldIntro" && this.tutorial.Step == 4) {
      this.startIntroJS(
        "#goBackBtn",
        this.$t("newTutorial.worldIntro.dialog_8"),
        2000
      );
    }
  },
  methods: {
    updatePortalState() {
      if (this.settings && this.settings.debug) {
        this.portalEnabled = true;
        return;
      }

      const startEnv = Number(process.env.VUE_APP_FUN_PORTAL_HOUR_START);
      const endEnv = Number(process.env.VUE_APP_FUN_PORTAL_HOUR_END);
      let startHour = Number.isInteger(startEnv) ? startEnv : 18;
      let endHour = Number.isInteger(endEnv) ? endEnv : 22;

      if (
        startHour < 0 ||
        startHour > 23 ||
        endHour < 1 ||
        endHour > 24 ||
        endHour <= startHour
      ) {
        startHour = 18;
        endHour = 22;
      }

      this.portalStartHour = startHour;
      this.portalEndHour = endHour;
      const hours = new Date().getHours();
      this.portalEnabled = hours >= startHour && hours < endHour;
    },
    formatHour(hour) {
      const normalized = Number.isInteger(hour) ? hour : 0;
      const suffix = normalized >= 12 ? "pm" : "am";
      const display = normalized % 12 === 0 ? 12 : normalized % 12;
      return `${display}${suffix}`;
    },
    isItemClosed(item) {
      return item.page === "PageFunArenaLanding" && !item.isOpen;
    },
    handleMenuClick(item) {
      if (item.page === "PageFunArenaLanding") {
        this.updatePortalState();
        item.isOpen = this.portalEnabled;
        if (!item.isOpen) {
          this.portalClosedDialog = true;
          return;
        }
      }
      this.$intro().exit();
      this.$router.push({
        name: item.page,
      });
    },
    startIntroJS(
      id,
      text,
      timeout = 1000,
      image = require("@/assets/tutorial/chat_1.png"),
      sfx = require("@/assets/sounds/sfx_chat_1.mp3")
    ) {
      this.intraction = "pointer-events: none;";
      setTimeout(() => {
        this.$intro().exit();
        this.$intro()
          .setOptions({
            exitOnOverlayClick: false,
            showButtons: false,
            showBullets: false,
            steps: [
              {
                element: document.querySelector(id),
                intro: '<img src="' + image + '">' + text,
              },
            ],
          })
          .start();
        this.intraction = "pointer-events: all;";
        let audio = new Audio(sfx);
        audio.volume = this.settings.audio.sfx * this.settings.audio.master;
        audio.play();
      }, timeout);
    },
    exit() {
      this.$intro().exit();
      this.$router.push({
        name: "PageWorldNews",
      });
    },
  },
};
</script>

<style scoped>
.menu-button {
  padding: 0 5px;
  cursor: pointer;
  width: 33.33%;
  display: flex;
  justify-content: center;
}

.menu-item {
  cursor: pointer;
}

.menu-item:hover {
  scale: 1.1;
}

.menu-item-closed {
  filter: grayscale(100%);
}

.app-title {
  z-index: 99;
  position: absolute;
  top: 0;
  max-width: 480px !important;
  width: 100%;
  display: flex;
  align-items: center;
  height: 60px;
  box-shadow: 0px 5px 2px rgba(128, 128, 128, 0.5) !important;
  border: #caad87 5px solid;
  margin: auto;
  color: #fff;
  background-color: #f7efe3;
  text-shadow: #cbb18f 3px 0px 0px, #cbb18f 2.83487px 0.981584px 0px,
    #cbb18f 2.35766px 1.85511px 0px, #cbb18f 1.62091px 2.52441px 0px,
    #cbb18f 0.705713px 2.91581px 0px, #cbb18f -0.287171px 2.98622px 0px,
    #cbb18f -1.24844px 2.72789px 0px, #cbb18f -2.07227px 2.16926px 0px,
    #cbb18f -2.66798px 1.37182px 0px, #cbb18f -2.96998px 0.42336px 0px,
    #cbb18f -2.94502px -0.571704px 0px, #cbb18f -2.59586px -1.50383px 0px,
    #cbb18f -1.96093px -2.27041px 0px, #cbb18f -1.11013px -2.78704px 0px,
    #cbb18f -0.137119px -2.99686px 0px, #cbb18f 0.850987px -2.87677px 0px,
    #cbb18f 1.74541px -2.43999px 0px, #cbb18f 2.44769px -1.73459px 0px,
    #cbb18f 2.88051px -0.838247px 0px;
}

.text-stroke-sm {
  color: #fff;
  text-shadow: #8b5629 3px 0px 0px, #8b5629 2.83487px 0.981584px 0px,
    #8b5629 2.35766px 1.85511px 0px, #8b5629 1.62091px 2.52441px 0px,
    #8b5629 0.705713px 2.91581px 0px, #8b5629 -0.287171px 2.98622px 0px,
    #8b5629 -1.24844px 2.72789px 0px, #8b5629 -2.07227px 2.16926px 0px,
    #8b5629 -2.66798px 1.37182px 0px, #8b5629 -2.96998px 0.42336px 0px,
    #8b5629 -2.94502px -0.571704px 0px, #8b5629 -2.59586px -1.50383px 0px,
    #8b5629 -1.96093px -2.27041px 0px, #8b5629 -1.11013px -2.78704px 0px,
    #8b5629 -0.137119px -2.99686px 0px, #8b5629 0.850987px -2.87677px 0px,
    #8b5629 1.74541px -2.43999px 0px, #8b5629 2.44769px -1.73459px 0px,
    #8b5629 2.88051px -0.838247px 0px;
}

.main-body {
  /*background-color: #c7e5e9;*/
  background-color: rgba(100, 255, 255, 0.3);
}

.app-body {
  max-width: 480px;
  min-height: 100%;
  padding: 80px 0 40px 0;
  /* background-color: #f5dfc5; */
}
</style>
